import moment from "moment";
import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";
import "./LineChart.css";

const LineChart = ({ graph, query }) => {
	const chartEl = useRef(null);
	const chartRef = useRef(null);

	useEffect(() => {
		return () => {
			if (chartRef.current) {
				chartRef.current.destroy();
				chartRef.current = null;
			}
		};
	}, []);

	useEffect(() => {
		if (!graph || graph.length === 0) return;

		const data =
			query === "week"
				? graph?.map((item) => item?.nb_user || 0)
				: graph?.map((item) => item?.users_count || 0);

		const labels =
			query === "week"
				? graph?.map((item) => moment(item?.day).format("dddd"))
				: query === "month"
				? graph?.map((item) => moment(item?.start_day).format("DD MMMM"))
				: graph?.map((item) => moment(item?.month).format("MMMM"));

		const maxY = Math.max(...data) || 0;
		const yMax = maxY <= 0 ? 10 : Math.round(maxY * 1.2);

		const options = {
			series: [
				{
					name: "Utilisateurs",
					data,
				},
			],
			chart: {
				type: "area",
				height: 350,
				background: "#FFFFFF",
				zoom: {
					enabled: false,
				},
				toolbar: {
					show: false,
				},
			},
			colors: ["#08BB90"],
			fill: {
				colors: ["#42922E"],
			},
			dataLabels: {
				enabled: false,
			},
			stroke: {
				width: 2,
				curve: "smooth",
			},
			xaxis: {
				categories: labels,
			},
			yaxis: {
				show: true,
				min: 0,
				max: yMax,
			},
			grid: {
				show: true,
				xaxis: {
					lines: {
						show: false,
					},
				},
				yaxis: {
					lines: {
						show: true,
					},
				},
			},
			legend: {
				show: false,
			},
		};

		if (chartRef.current) {
			chartRef.current.updateOptions(options, false, true);
			chartRef.current.updateSeries([
				{
					name: "Utilisateurs",
					data,
				},
			]);
		} else if (chartEl.current) {
			chartRef.current = new ApexCharts(chartEl.current, options);
			chartRef.current.render();
		}
	}, [query, JSON.stringify(graph)]);

	if (!graph || graph.length === 0) {
		return <div>Aucune donnée disponible pour le graphique</div>;
	}

	return <div ref={chartEl} className="chart-dashboard-marketplace" />;
};

export default LineChart;
